"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ArtistTypeEnum = void 0;
var ArtistTypeEnum;
(function (ArtistTypeEnum) {
    ArtistTypeEnum["Individual"] = "Individual";
    ArtistTypeEnum["MusicalArtist"] = "Musical Artist";
    ArtistTypeEnum["Film"] = "Film";
})(ArtistTypeEnum = exports.ArtistTypeEnum || (exports.ArtistTypeEnum = {}));
//# sourceMappingURL=IArtist.js.map